module.exports = {"id":"206141","name":"Kalifa Coulibaly","rating":"72","photo":"./data/images/photos/0/206141.png","club":{"name":"FC Nantes","logo":"./data/images/clubs/FCNantes.png"},"positions":["BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KalifaCoulibaly0.json
// module id = 2280
// module chunks = 0